if ($('#coms-ratings-tv-audience-comp').length) {

    $('#custom_chart').on('click', function () {
        var html_type= ' <option value=""></option>' +
            '                                            <option value="pie">Pie</option>' +
            '                                            <option value="column">Column (Vertical)</option>' +
            '                                            <option value="bar">Column (Horizontal)</option>';

        $('#chart_type').select2({
            minimumResultsForSearch: 5,
            placeholder: 'Select one....',
        });
        $('#chart_type').html(html_type);
        $('#chart_data_type').select2({
            minimumResultsForSearch: 5
        });
        $('#chart_demo_options').select2({
            placeholder: "Select at least one..",
            closeOnSelect: false,
            placeholder: 'Select at least one....',
        });

        var table=   $('#ratings_audience_comp_table ').DataTable();
        console.log('table',table);
        var ages=[];
        table.rows().eq(0).each( function ( index ) {
            var row = table.row( index );

            var data = row.data();
            console.log('row.data', data)
            ages.push(data['ages']);
        } );
        $('#chart_age').multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_dayparts'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_dayparts'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
            afterInit: function (ms) {
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function (e) {
                        if (e.which === 40) {
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function (values) {
                this.qs1.cache();
                // if( $('#chart_type option:selected').val() === 'pie') {
                //     form_curr_dayparts = this.$element.val();
                //     if (this.$element.val().length > 1) {
                //         this.$element.multiSelect('deselect', values);
                //         form_curr_dayparts = this.$element.val();
                //
                //         swal({
                //                 title: "Warning",
                //                 text: "The max number is 1 ...",
                //                 type: "warning",
                //                 showCancelButton: true,
                //                 confirmButtonClass: "btn-danger",
                //                 confirmButtonText: "OK",
                //                 cancelButtonText: "Close",
                //                 closeOnConfirm: true,
                //                 closeOnCancel: true
                //             },
                //             function (isConfirm) {
                //
                //             });
                //     }
                //     if (form_curr_dayparts.length < 2)
                //         this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                //     else
                //         this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-muted').addClass('text-warning');
                //
                // }
            },
            afterDeselect: function (values) {
                this.qs1.cache();
                // if( $('#chart_type option:selected').val() == 'pie') {
                //     form_curr_dayparts = this.$element.val();
                //     this.$element.closest('.form_dayparts_container_chart').find('.select-count').html('(' + form_curr_dayparts.length + ' / 1)').removeClass('text-warning').addClass('text-muted');
                // }
            }
        });
        var html = '';
        for(var i in ages)
            html +='<option value="'+ages[i]+'">'+ages[i]+'</option>';
        $('#chart_age').html(html).multiSelect('refresh');
        $('#sel_all_chart_dayparts').on('click', function (e) {
            $('#chart_age').multiSelect('select_all');
        });
        $('#desel_all_chart_dayparts').on('click', function (e) {
            $('#chart_age').multiSelect('deselect_all');
        });

        $('#graphsOptionsModal').modal('show');
    });
    $('#submit_charts_options').on('click', function(){
        if($('#chart_type option:selected').val() == ''){
            swal({
                    title: "Warning",
                    text: "Select Chart Type first...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_demo_options').val().length == 0){
            swal({
                    title: "Warning",
                    text: "Select at least one Demo...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_age').val().length == 0){
            if($('#chart_type option:selected').val() === 'pie')
                text= 'Select a Age first...';
            else
                text= 'Select at least one Age Range...';
            swal({
                    title: "Warning",
                    text: text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else {
            show_overlay_loader('#graphsOptionsModal .modal-content');
            var age_charts = $('#chart_age').val();
            var data_type ='impressions';
            var demo_type = $('#chart_demo_options').val();
            var columns = [];
            for (var b in demo_type) {
                var string = '';
                string += demo_type[b]+'_'+data_type;
                columns.push(string);
            }
            console.log('columns', columns);
            console.log('vendor_charts', age_charts);
            console.log('demo_type', demo_type);
            var results=[];
            var results_per=[];
            var thousands_total = 0;
            for(var i in demo_type) {
                results[demo_type[i]] = [];
                results_per[demo_type[i]] = [];
                for(var y in age_charts) {
                    results[demo_type[i]][age_charts[y]] = [];
                    results_per[demo_type[i]][age_charts[y]] = [];
                }
            }
            var demo_names={
                m: 'Men',
                f: 'Women',
                p: 'Person',
            };
            console.log('results', results);

            var table=   $('#ratings_audience_comp_table ').DataTable();

            table.rows().eq(0).each( function ( index ) {
                var row = table.row( index );
                var data = row.data();
                console.log('row.data', data)
                if(age_charts.indexOf(data['ages']) !== -1 ){
                    for(var i in columns){
                        var string= columns[i].split('_');
                        results[string[0]][data['ages']][columns[i]]= (!isNaN(data[columns[i]])) ? data[columns[i]] : 0;
                        thousands_total += (!isNaN(data[columns[i]])) ? parseFloat(data[columns[i]]) : 0;
                        results_per[string[0]][data['ages']][string[0]+'_per']= (!isNaN(data[string[0]+'_per'])) ? data[string[0]+'_per'] : 0;
                    }
                }
            });

            console.log('results', results);

            if ($('#chart_type option:selected').val() == 'column' || $('#chart_type option:selected').val() == 'bar') {
                var series=[];
                for(var demo in results){
                    var data=[];
                    for(var age in results[demo]){
                        for(var col in results[demo][age]){
                            var string= col.split('_');
                            var perc= string[0]+'_per';
                            if($('#chart_data_type option:selected').val() == 'both') {
                                data.push({
                                    name: age,
                                    y: parseFloat(results[demo][age][col]),
                                    percentage: parseFloat(results_per[demo][age][perc]),
                                    drilldown: null,
                                });
                            }
                            else if($('#chart_data_type option:selected').val() == 'impressions'){
                                data.push({
                                    name: age,
                                    y: parseFloat(results[demo][age][col]),
                                    // percentage: parseFloat(results_per[demo][age][perc]),
                                    drilldown: null,
                                });
                            }
                            else{
                                data.push({
                                    name: age,
                                    y: parseFloat(results_per[demo][age][perc]),
                                    drilldown: null,
                                });
                            }

                            // data.push({
                            //     name: age,
                            //     y: parseFloat(results[demo][age][col]),
                            //     percentage: parseFloat(results_per[demo][age][perc]),
                            //     drilldown: null,
                            // });
                        }
                    }
                    series.push({
                        name: demo_names[demo],
                        data: data,
                    });
                }
                console.log('series', series)
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                var format = '';
                if($('#chart_data_type option:selected').val() == 'both')
                    format = '<b>{point.y:.0f}  </b>({point.percentage:.1f}%)';
                else if($('#chart_data_type option:selected').val() == 'impressions')
                    format = '<b>{point.y:.0f} </b>';
                else
                    format = '<b>{point.y:.1f} % </b>';

                var dt_type= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type = $('#chart_data_type option:selected').html();
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type = $('#chart_data_type option:selected').html();
                else
                    dt_type = 'Thousands (000) & Percent (%)';

                Highcharts.chart('container_graphs', {
                    chart: {
                        type: $('#chart_type option:selected').val(),
                    },
                    title: {
                        text: $('#book').html(),
                    },
                    subtitle:{
                        text:  $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ' )',
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: dt_type,
                        },
                        min: 0,
                    },
                    credits: {
                        text: 'GaleForce Digital, Inc.',
                    },
                    plotOptions: {
                        column: {
                            pointPadding: 0.2,
                            borderWidth: 0
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px"><b>{point.key}</b></span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:5 px">'+ format +'</td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    series: series,
                });
            }
            else{
                var series = [];
                var data2 = [];
                for(var demo in results){
                    var total = 0;
                    var arr= [];
                    var cont=0;
                    for(var age in results[demo]){
                        var total_age= 0;
                        for(var col in results[demo][age]){
                            var string= col.split('_');
                            var perc= string[0]+'_per';
                            total += parseFloat(results[demo][age][col]);
                            total_age += parseFloat(results[demo][age][col]);
                        }
                        arr.push({name: age, y: total_age, x: parseFloat(results_per[demo][age][perc]), drilldown: null});
                        cont++;
                    }
                    data2.push({
                        name: demo_names[demo],
                        id: demo,
                        data: arr,
                    });
                    var percent = 0;
                    percent= (thousands_total > 0) ? parseFloat(((total * 100) / thousands_total)).toFixed(2) : 0;
                    series.push({
                        name: demo_names[demo],
                        y: total,
                        x: percent,
                        drilldown: demo,
                    });
                }
                console.log('data2', data2);
                console.log('series', series)
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                var format = '';
                if($('#chart_data_type option:selected').val() == 'both')
                    format = '<b>{point.y:.0f}  </b>({point.x:.1f}%)';
                else if($('#chart_data_type option:selected').val() == 'impressions')
                    format = '<b>{point.y:.0f} </b>';
                else
                    format = '<b>{point.x:.1f} % </b>';

                var dt_type= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type = $('#chart_data_type option:selected').html();
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type = $('#chart_data_type option:selected').html();
                else
                    dt_type = 'Thousands (000) & Percent (%)';

                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type_name = "Thousands";
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type_name = "Percent"
                else
                    dt_type_name = 'Thousands & Percent';
                Highcharts.chart('container_graphs', {
                    chart: {
                        type: $('#chart_type option:selected').val(),
                    },
                    title: {
                        text: $('#book').html(),
                    },
                    subtitle:{
                        text:    $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ')<br> <span style="color: red"> Click the slices to view  '+ dt_type +' by Age Range. </span>', },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: dt_type,
                        },
                        min: 0,
                    },
                    credits: {
                        text: 'GaleForce Digital, Inc.',
                    },
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true,
                                // format: '${point.y:.2f}'
                            },
                            showInLegend: true,
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px"><b>{point.key}</b></span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">'+ dt_type_name +': </td>' +
                            '<td style="padding: 5px"><b>' +format + '</b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    series: [
                        {
                            name: 'Thousands',
                            colorByPoint: true,
                            data: series
                        }
                    ],
                    drilldown: {
                        series: data2
                    }
                });
            }

            $('#GraphsModal').modal('show');
            hide_overlay_loader('#graphsOptionsModal .modal-content');
        }
    });

    var form_coms_markets;
    var dt;

    $(document).ready(function(){
        show_loader();
        dayPartInputInit('16:00', '23:00', 'tv');
        $.ajax({
            type: "GET",
            url: '/comscore/tv/local/markets',
            dataType: 'json',
            success: function (data) {
                var html = '<option value="">Select one...</option>';
                $.each(data['result_rows'], function (index, value) {
                    html += '<option value="'+ value[0] +'" data-start="' + value[2] + '" data-end="' + value[3] + '">'+ value[1] +'</option>';
                });
                $("#coms_form_market").html(html);

                form_coms_markets = data;
                console.log("init");
                $("#coms_form_market").select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10
                }).on('select2:select', function (evt) {
                    onMarketChange1($(this).val());
                });

                $('#form_reset').bind('click', function(){
                    compAudienceReset1();
                });

                $('#form_submit_coms').bind('click', function(){
                    compAudienceSubmit1();
                });

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });

        $('#export_excel_aud').on('click', function(){
            var x= $('#book').html() +' >  ' + $('#distributor').html() +' >  '+ $('#day_part').html();

            var html_header= '<table> ' +
                '<tr> ' +
                '<td style="background-color: #f5f5f5" colspan="10"><span style="font-size: 18px">  <b> Comscore Television Ratings Audience Composition<b></span></td>' +
                '</tr> ' +
                '<tr></tr></table><table>' +
                '<tr>' +
                '<td style="background-color: #f5f5f5; font-size: 15px " colspan="10"> ' + x+ '</td></tr>' +
                '<tr></tr>' +
                '</table>';

            $("#ratings_audience_comp_table th:contains(Men)")
                .css("background-color", "#f2643d");
            $("#ratings_audience_comp_table th:contains(Women)")
                .css("background-color", "#f2643d");
            $("#ratings_audience_comp_table th:contains(Persons)")
                .css("background-color", "#f2643d");
            $("#ratings_audience_comp_table th:contains(Demo)")
                .parents("tr")
                .css("background-color", "#f8ab91");
            $("#ratings_audience_comp_table tbody tr:odd")
                .css("background-color", "#f0ffff");
            $("#ratings_audience_comp_table tbody td")
                .css("padding", "80px");

            html_header += $('.audience-ratings-table').html();

            exportToExcel(html_header);
        });
    });

    $("#form_from, #form_to").on("focusout", function () {
        if(moment($(this).val()) > moment($("#coms_form_market option:selected").data("end")) || moment($(this).val()) < moment($("#coms_form_market option:selected").data("start"))) {
            global_notification("warning", "The dates has to be between " + moment($("#coms_form_market option:selected").data("start")).format("MM/DD/YYYY") + " and " + moment($("#coms_form_market option:selected").data("end")).format("MM/DD/YYYY") + ".")
            $(this).val(($(this).attr("id") === "form_from") ? $("#coms_form_market option:selected").data("start") : $("#coms_form_market option:selected").data("end"))
        }
    })

    var onMarketChange1 = function(market){
        show_loader();
        $("#form_from").attr("min", $("#coms_form_market option:selected").data("start"))
        $("#form_from").attr("max", $("#coms_form_market option:selected").data("end"))
        $("#form_from").val($("#coms_form_market option:selected").data("start"))
        $("#form_to").attr("min", $("#coms_form_market option:selected").data("start"))
        $("#form_to").attr("max", $("#coms_form_market option:selected").data("end"))
        $("#form_to").val($("#coms_form_market option:selected").data("end"))
        $.ajax({
            type: "GET",
            url: '/ratings/comscore/stations/' + market,
            dataType: 'json',
            success: function (data) {
                console.log(data);
                var html = '';
                $.each(data['result_rows'], function (index, value) {
                    if(value[5] == market)
                        html += '<option value="'+ value[0] +'">'+ value[1] +' ('+ value[10] +')</option>';
                });
                $("#form_comp_station").html(html);
                $("#form_comp_station").select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10
                }).on('select2:select', function (evt) {

                });
                hide_loader();
            },
            error: function (err) {
                hide_loader();
            }
        });
    };

    var compAudienceReset1 = function(sel){
        var input = $('#coms_form_market');

        input.data('select2').destroy();
        input.unbind('select2:select');

        var html = '';
        $.each(form_coms_markets['result_rows'], function (index, value) {
            html += '<option value="'+ value[0] +'">'+ value[1] +'</option>';
        });
        input.html(html);
        input.select2({
            placeholder: "Select one...",
            minimumResultsForSearch: 10
        }).on('select2:select', function (evt) {
            onMarketChange(this);
        });

        input = $('#form_comp_station');
        input.data('select2').destroy();
        input.unbind('select2:select');
        input.html('');
        input.select2({
            placeholder: "Select a station...",
            minimumResultsForSearch: 10
        });

        $("#form_from").val("");
        $("#form_to").val("");

    };

    var compAudienceSubmit1 = function(){
        show_loader();
        var dp_start = moment($('#form_day_part_start').val(), 'h:mm A');
        var dp_end = moment($('#form_day_part_end').val(), 'h:mm A');
        var station = $("#form_comp_station option:selected").val();
        var from = $("#form_from").val();
        var to = $("#form_to").val();
        var market = $("#coms_form_market option:selected").val();
        var days = $('#form_day_part_days').val();
        var day_part_str = $('#form_day_part_days').val() + dp_start.format('HHmm') + dp_end.format('HHmm');

        $.ajax({
            url: '/ratings/comscore/composition/audience?' + $.param({
                start_time: dp_start.format('HH:mm:00'),
                end_time: dp_end.format('HH:mm:00'),
                days: days,
                from: from,
                to: to,
                market: market,
                distributor: station
            }),
            success: function (data) {
                console.log(data);

                //if(typeof data['data']['result_rows'][0] !== "undefined" && data['data']['result_rows'][0].length > 0) {

                    $('#book').html($("#coms_form_market option:selected").text());
                    $('#distributor').html($("#form_comp_station option:selected").text());
                    $('#day_part').html(ratingsHumanDaypart(day_part_str));

                    var programs = data['series']['result_rows'];
                    $('#programs').html('');
                    $.each(programs, function (index, item) {
                        $('#programs').append('<li><i class="fa fa-fw fa-angle-double-right text-primary"></i>&nbsp;' + item[2] + '</li>');
                    });

                    var table_data = [];
                    var inda = 3;
                    var indm = 15;
                    var indw = 27;
                    $.each(data['demos']["A"], function (index, value) {
                        var push = {
                            'ages': index
                        };

                        push['m_impressions'] = (typeof data['data']['result_rows'][0] !== "undefined" && typeof data['data']['result_rows'][0][indm + 1] !== "undefined") ? Number(Math.round((data['data']['result_rows'][0][indm + 1]) + 'e1') + 'e-1') : 0;
                        if (isNaN(push['m_impressions']))
                            push['m_impressions'] = 0;
                        push['m_per'] = (typeof data['data']['result_rows'][0] !== "undefined" && typeof data['data']['result_rows'][0][indm + 1] !== "undefined" && typeof data['data']['result_rows'][0][2] !== "undefined" && data['data']['result_rows'][0][2] > 0) ? Number(Math.round((100 * data['data']['result_rows'][0][indm + 1] / data['data']['result_rows'][0][2]) + 'e1') + 'e-1') : 0;
                        if (isNaN(push['m_per'])) {
                            //console.log(data['data']['result_rows'][0][indm + 1]);
                            //console.log(data['data']['result_rows'][0][2]);
                            push['m_per'] = 0;
                        }
                        push['m_intab'] = true;

                        push['f_impressions'] = (typeof data['data']['result_rows'][0] !== "undefined" && typeof data['data']['result_rows'][0][indw + 1] !== "undefined") ? Number(Math.round((data['data']['result_rows'][0][indw + 1]) + 'e1') + 'e-1') : 0;
                        if (isNaN(push['f_impressions']))
                            push['f_impressions'] = 0;
                        push['f_per'] = (typeof data['data']['result_rows'][0] !== "undefined" && typeof data['data']['result_rows'][0][indw + 1] !== "undefined" && typeof data['data']['result_rows'][0][2] !== "undefined" && data['data']['result_rows'][0][2] > 0) ? Number(Math.round((100 * parseFloat(data['data']['result_rows'][0][indw + 1]) / parseFloat(data['data']['result_rows'][0][2])) + 'e1') + 'e-1') : 0;
                        if (isNaN(push['f_per']))
                            push['f_per'] = 0;
                        push['f_intab'] = true;

                        var total = push['m_impressions'] + push['f_impressions'];

                        push['p_impressions'] = Number(Math.round((total) + 'e1') + 'e-1');
                        if (isNaN(push['p_impressions']))
                            push['p_impressions'] = 0;
                        push['p_per'] = (typeof data['data']['result_rows'][0] !== "undefined" && typeof data['data']['result_rows'][0][2] !== "undefined" && data['data']['result_rows'][0][2] > 0) ? Number(Math.round((100 * total / data['data']['result_rows'][0][2]) + 'e1') + 'e-1') : 0;
                        if (isNaN(push['p_per']))
                            push['p_per'] = 0;
                        push['p_intab'] = true;

                        indm += 2;
                        indw += 2;
                        inda += 2;

                        table_data.push(push);
                    });

                    if (typeof dt !== 'undefined') {
                        dt.destroy();
                        $('#ratings_audience_comp_table').find('tbody').empty();
                    }

                    dt = $('#ratings_audience_comp_table').DataTable({
                        columns: [
                            {
                                data: "ages"
                            }, {
                                data: "m_impressions"
                            }, {
                                data: "m_per"
                            }, {
                                data: "f_impressions"
                            }, {
                                data: "f_per"
                            }, {
                                data: "p_impressions"
                            }, {
                                data: "p_per"
                            }
                        ],
                        "columnDefs": [
                            {
                                "orderable": false,
                                "targets": '_all'
                            },
                            {
                                render: function (data, type, row, meta) {
                                    var curr_intab = true;
                                    var html = '';
                                    if (meta['col'] === 2) {
                                        if (!row['m_intab']) {
                                            html += '<span class="pull-left">✝</span>';
                                            curr_intab = false;
                                        }
                                    } else if (meta['col'] === 4) {
                                        if (!row['f_intab']) {
                                            html += '<span class="pull-left">✝</span>';
                                            curr_intab = false;
                                        }
                                    } else if (meta['col'] === 6) {
                                        if (!row['p_intab']) {
                                            html += '<span class="pull-left">✝</span>';
                                            curr_intab = false;
                                        }
                                    }

                                    html += data;
                                    export_html = html;
                                    return html;
                                },
                                targets: [2, 4, 6]
                            },
                        ],
                        "order": [],
                        //   dom: 'Bfrtip',
                        /* buttons: [
                             'copy',
                             {
                                 extend: 'excel',
                                 messageTop:  $('#book').html() +' >  ' + $('#distributor').html() +' >  '+ $('#day_part').html(),
                             },
                             {
                                 extend: 'csv',
                                 messageTop:  $('#book').html() +' >  ' + $('#distributor').html() +' >  '+ $('#day_part').html(),
                             },
                             {
                                 extend: 'print',
                                 messageTop:   $('#book').html() +' >  ' + $('#distributor').html() +' >  '+ $('#day_part').html(),
                             },
                         ],*/
                        "searching": false,
                        "paging": false,
                        "info": false,
                        data: table_data,
                    });

                    if ($('.ratings-table-container').hasClass('hidden')) {
                        $('.ratings-table-container').removeClass('hidden');
                    }

                    $('#tv_comp_audience_generate_panel').find('div.clickable').click();

                    hide_loader();
                // }else{
                //     global_notification("warning","There is not data for this report inputs.")
                //     hide_loader();
                // }
            },
            error: function (err) {
                ajax_error();
                debug(err.responseText);
                hide_loader();
            }
        });

    };


    var exportToExcel = function(html){
        html += '<br/><br/><table cellspacing="0" style="width: 100%;"><tbody><tr><td colspan="7" style="font-weight: bold;padding:2px 2px 2px 6px;width: 100%;">LEGAL DISCLAIMER</td></tr><tr><td colspan="7" style="padding:2px 2px 2px 6px;width: 100%;">All metrics contained in this document are calculations of GaleForce Digital Technologies and have not been verified by Comscore.</td></tr></tbody></table>'
        var url='data:application/vnd.ms-excel,' + encodeURIComponent(html);
        location.href=url;
        return false;
    };

}
